export default {
  vipUpgrade: {
    title: 'Selamat!!',
    message: 'Anda telah dipromosikan dari VIP{from} ke VIP{to}',
    subtitle: 'Terima kasih atas dukungan Anda. Level baru membawa\nlayanan eksklusif dan hak istimewa khusus.',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
